var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRationEditLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.6197 7.70711C23.0252 7.31658 23.0252 6.68342 22.6197 6.29289L18.4658 2.29289C18.0603 1.90237 17.4028 1.90237 16.9972 2.29289L3.49722 15.2929C3.30247 15.4804 3.19306 15.7348 3.19306 16V20C3.19306 20.5523 3.658 21 4.23152 21H8.38537C8.66079 21 8.92492 20.8946 9.11967 20.7071L19.5041 10.7073L22.6197 7.70711ZM17.3014 10L7.95522 19H5.26998V16.4142L14.6161 7.41421L17.3014 10ZM16.0847 6L17.7315 4.41422L20.4168 7L18.77 8.58579L16.0847 6Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRationEditLogo);
export default __webpack_public_path__ + "static/media/ration_edit_logo.bc89fa8b405a6b633bfd369534e0a043.svg";
export { ForwardRef as ReactComponent };